import gql from 'graphql-tag'


export const SQUAD = gql`
    query userGlamSquadMember($id: String!) {
        userGlamSquadMember(id: $id) {
            id
            user {
                id
            }
            member {
                id
                firstName
                lastName
                avatar
                profile {
                    nickName
                }
            }
        }
    }
`

export const SQUADS = gql`
    query userGlamSquadMembers($userId: String) {
        userGlamSquadMembers(userId: $userId) {
            id
            user {
                id
            }
            member {
                id
                firstName
                lastName
                avatar
                profile {
                    nickName
                }
            }
        }
    }
`

export const CREATE_SQUADS = gql`
 mutation createUserSquads($data: UserGlamSquadMemberInput) {
    createUserSquads(data: $data) {
        id
    }
 }
`

export const UPDATE_SQUAD = gql`
 mutation updateUserGlamSquadMember($id: String!, $data: UserGlamSquadMemberInput) {
    updateUserGlamSquadMember(id: $id, data: $data) {
        id
    }
 }
`

export const DELETE_SQUAD = gql`
 mutation deleteUserGlamSquadMember($id: String!) {
    deleteUserGlamSquadMember(id: $id)
 }
`

